export default __webpack_public_path__ + "static/media/error.3b9b778d.png";